import React, { useState, useEffect } from "react";
import { Radar } from "@ant-design/plots";

const RadarPlot = ({ data, style }) => {
  //console.log("radar data: ", data);
  const config = {
    data,
    xField: "item",
    yField: "bagPercent",
    seriesField: "user",
    meta: {
      bagPercent: {
        alias: "Percent",
        min: 0,
        max: 100,
      },
    },
    xAxis: {
      line: null,
      tickLine: null,
      grid: {
        line: {
          style: {
            lineDash: null,
          },
        },
      },
    },
    autoFit: true,
    yAxis: {
      line: null,
      tickLine: null,
      grid: {
        line: {
          type: "line",
          style: {
            lineDash: null,
          },
        },
        alternateColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    area: {},
    point: {
      size: 2,
    },
  };

  return <Radar style={style} {...config} />;
};

export default RadarPlot;
